// 将时间戳转换成日期格式
export function timestampToTime(timestamp) {
  const time = new Date(timestamp)
  const y = time.getFullYear()
  const m = time.getMonth() + 1
  const d = time.getDate()
  const h = time.getHours()
  const mm = time.getMinutes()
  const s = time.getSeconds()
  return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm) + ':' + add0(s)
}

// 转换日期格式
export function timestampToTime2(time) {
  const y = time.getFullYear()
  const m = time.getMonth() + 1
  const d = time.getDate()
  const h = time.getHours()
  const mm = time.getMinutes()
  const s = time.getSeconds()
  return y + '' + add0(m) + '' + add0(d) + '' + add0(h) + '' + add0(mm) + '' + add0(s)
}

// 将时间转换成日期格式
export function timestampToTime3(time) {
  const y = time.getFullYear()
  const m = time.getMonth() + 1
  const d = time.getDate()
  const h = time.getHours()
  const mm = time.getMinutes()
  const s = time.getSeconds()
  return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm) + ':' + add0(s)
}

// 将时间戳转换成日期格式
export function timestampToTime4(timestamp) {
  const time = new Date(timestamp)
  const y = time.getFullYear()
  const m = time.getMonth() + 1
  const d = time.getDate()
  return y + '' + add0(m) + '' + add0(d)
}

export function timeToDate2 (time) {
  const y = time.getFullYear()
  const m = time.getMonth() + 1
  const d = time.getDate()
  const h = time.getHours()
  const mm = time.getMinutes()
  return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm)
}

// 转换日期格式
export function timestampToYMD(time) {
  const y = time.getFullYear()
  const m = time.getMonth() + 1
  const d = time.getDate()
  return y + '-' + add0(m) + '-' + add0(d)
}

// 转换日期格式(年月日时分)
export function timesToMin(time) {
  const y = time.getFullYear()
  const m = time.getMonth() + 1
  const d = time.getDate()
  const h = time.getHours()
  const mm = time.getMinutes()
  return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm)
}

function add0(m) {
  return m < 10 ? '0' + m : m
}

// 计算时间差
export function timeFn(d1) {
  // 如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
  const dateBegin = new Date(d1.replace(/-/g, '/'))// 将-转化为/，使用new Date
  const dateEnd = new Date()// 获取当前时间
  const dateDiff = dateEnd.getTime() - dateBegin.getTime()// 时间差的毫秒数
  const minutes = Math.floor(dateDiff / (60 * 1000))// 计算相差分钟数
  return minutes
}

// 计算两个时间差
export function timeANDTimeFn(d1, d2) {
  // 如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
  const dateBegin = new Date(d1)// 将-转化为/，使用new Date
  const dateEnd = new Date(d2)
  const dateDiff = dateEnd.getTime() - dateBegin.getTime()// 时间差的毫秒数
  const hour = (dateDiff / (60 * 60 * 1000)).toFixed(2) // 计算相差小时
  return hour
}



// WEBPACK FOOTER //
// ./src/utils/timestamp.js